"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllTabuProcedures = exports.ConvertToFreehold = exports.DelayedPropertyAnnex = exports.PropertyAnnex = exports.DelayedPropertyCutOff = exports.PropertyCutOff = exports.OwnershipChange = exports.IPVTypes = exports.BCSReClassification = exports.IPV = exports.LC = exports.PV = exports.ET = exports.SitePlan = exports.PropertyDetailCertService = exports.TWICService = void 0;
var entity_1 = require("./entity");
exports.TWICService = {
    Id: entity_1.ProcedureIDs.TO_WHOM_CONCERN,
    Name: {
        ar: "طلب إصدار شهادة بيان املاك العميل (لمن يهمه الامر)",
        en: "To whom it may concern",
    },
    Description: {
        ar: "تتيح هذه الخدمة للمتعاملين القيام بتسجيل طلب إصدار شهادة بيان أملاك المتعامل أو شهادة استيفاء بالمتطلبات الخاصة بإدارة العقارات.",
        en: "This service allows clients to apply for issuing a Statement of Customer Property or a Certificate of Satisfaction of Property Management Requirements.",
    },
    RequireProperty: false,
    HappinessServiceId: 438,
    IsActive: true,
};
exports.PropertyDetailCertService = {
    Id: entity_1.ProcedureIDs.PROPERTY_DETAIL_CERT,
    Name: {
        ar: "طلب بيان عقار تفصيلي",
        en: "Request for Detailed Property Certificate",
    },
    Description: {
        ar: "تتيح هذه الخدمة للمتعاملين القيام بتسجيل طلب إصدار شهادة بيان تفصيلية لعقار أو شهادة استيفاء بالمتطلبات الخاصة بإدارة العقارات.",
        en: "This service allows clients to apply for issuing a Statement of Customer Specific Property or a Certificate of Satisfaction of Property Management Requirements.",
    },
    RequireProperty: true,
    HappinessServiceId: 0,
    IsActive: true,
};
exports.SitePlan = {
    Id: entity_1.ProcedureIDs.SITE_PLAN,
    Name: {
        ar: "طلب اصدار خارطة",
        en: "Site Plan",
    },
    Description: {
        en: "This Service enables clients to request the issuance of a map as per the approved plans from the Survey Section at Land Department.",
        ar: "تتيح هذه الخدمة للمتعاملين  التقدم بطلب لإصدار خارطة لعقار حسب أنواع الخرائط المعتمدة في خدمات قسم المخططات في الدائرة.",
    },
    RequireProperty: true,
    HappinessServiceId: 474,
    IsActive: true,
};
exports.ET = {
    Id: entity_1.ProcedureIDs.ELECTRONIC_TITLE_DEED,
    Name: {
        ar: "سند الملكية الإلكتروني",
        en: "Electronic Title Deed",
    },
    Description: {
        ar: "تتيح هذه الخدمة للمتعاملين  التقدم بطلب لإصدار سند ملكية الكترونى.",
        en: "This Service enables clients to request the issuance of an electronic Title Deed.",
    },
    RequireProperty: true,
    HappinessServiceId: 0,
    IsActive: true,
};
exports.PV = {
    Id: entity_1.ProcedureIDs.PROPERTY_VALUATION,
    Name: {
        ar: "شهادة تثمين",
        en: "Valuation Certificate",
    },
    Description: {
        en: "This Service enables clients to request the issuance of a property valuation certificate.",
        ar: "تتيح هذه الخدمة للمتعاملين  التقدم بطلب لإصدار شهادة تثمين عقارى.",
    },
    RequireProperty: true,
    HappinessServiceId: 480,
    IsActive: true,
};
exports.LC = {
    Id: entity_1.ProcedureIDs.LOSS_CERTIFICATE,
    Name: {
        ar: "طلب إصدار ملكية بدل فاقد",
        en: "Loss Certificate",
    },
    Description: {
        en: "This service enables customers who are landlords to request the issuance of a replacement of damaged or lost title deed."
            + "The title deed is issued after posting an advertisement in the newspaper and after the expiry of the legal period, to avoid any objection. ",
        ar: "تتيح هذه الخدمة للعملاء القيام بتسجيل طلب إصدار ملكية بدل تالف او فاقد عن طريق طلب من مالك الأرض أو العقار، و تصدر الملكية بعد نشر إعلان في الصحف و بعد مرور الفترة القانونية تحسبا لأي اعتراض",
    },
    RequireProperty: true,
    HappinessServiceId: 530,
    IsActive: true,
};
exports.IPV = {
    Id: entity_1.ProcedureIDs.INTERNAL_PROPERTY_VALUATION,
    Name: {
        ar: "تقييم عقار داخلى",
        en: "Internal Property Evaluation",
    },
    Description: {
        en: "Procedure to evaluate the property for grant purpose",
        ar: "إجراء لتقييم عقار بغرض الهبة",
    },
    RequireProperty: true,
    HappinessServiceId: 480,
    IsActive: true,
};
exports.BCSReClassification = {
    Id: entity_1.ProcedureIDs.BCS_RE_CLASSIFICATION,
    Name: {
        ar: "bcs_reclassification",
        en: "bcs_reclassification",
    },
    Description: {
        en: "bcs_reclassification",
        ar: "bcs_reclassification",
    },
    RequireProperty: true,
    HappinessServiceId: 0,
    IsActive: true,
};
exports.IPVTypes = [
    {
        Identity: 4,
        NameAr: "الهبة",
        NameEn: "Grant",
    },
];
exports.OwnershipChange = {
    Id: entity_1.ProcedureIDs.OWNERSHIP_CHANGE,
    Name: {
        ar: "طلب تحديث مساحة عقار",
        en: " Update Property Area Request",
    },
    Description: {
        en: "Request to change property suit area, balcony area, common area & parking.",
        ar: "طلب لتعديل بيانات الهندسية لعقار مثل مساحة العقار الداخلية و مساحة البلكونة و المساحات المشتركة و المواقف",
    },
    RequireProperty: true,
    HappinessServiceId: 460,
    IsActive: true,
};
exports.PropertyCutOff = {
    Id: entity_1.ProcedureIDs.PROPERTY_CUT_OFF,
    Name: {
        ar: "فصل عقار",
        en: "Property Cut Off",
    },
    Description: {
        en: "This Service enables clients to request subdivision for on property from the Survey Section at Land Department.",
        ar: "تتيح هذه الخدمة للمتعاملين التقدم بطلب لفصل عقار في خدمات قسم المخططات في الدائرة.",
    },
    RequireProperty: true,
    IsActive: true,
};
exports.DelayedPropertyCutOff = {
    Id: entity_1.ProcedureIDs.DELAYED_PROPERTY_CUT_OFF,
    Name: {
        ar: " فصل عقار مؤجل",
        en: "Delayed Property Cut Off",
    },
    Description: {
        en: "This Service enables clients to request subdivision for on delayed property from the Survey Section at Land Department.",
        ar: "تتيح هذه الخدمة للمتعاملين التقدم بطلب فصل عقار فصل مؤجل في خدمات قسم المخططات في الدائرة.",
    },
    RequireProperty: true,
    IsActive: true,
};
exports.PropertyAnnex = {
    Id: entity_1.ProcedureIDs.PROPERTY_ANNEX,
    Name: {
        ar: "ضم عقار",
        en: "Property Annexation",
    },
    Description: {
        en: "This Service enables clients to request subdivision for on property Annexation from the Survey Section at Land Department.",
        ar: "تتيح هذه الخدمة للمتعاملين التقدم بطلب ضم عقار في خدمات قسم المخططات في الدائرة",
    },
    RequireProperty: true,
    IsActive: true,
};
exports.DelayedPropertyAnnex = {
    Id: entity_1.ProcedureIDs.DELAYED_PROPERTY_ANNEX,
    Name: {
        ar: "ضم عقار مؤجل",
        en: "Delayed Property Annex",
    },
    Description: {
        en: "This Service enables clients to request subdivision for on Delayed property Annexation from the Survey Section at Land Department.",
        ar: "تتيح هذه الخدمة للمتعاملين التقدم بطلب ضم عقار مؤجل في خدمات قسم المخططات في الدائرة.",
    },
    RequireProperty: true,
    IsActive: true,
};
exports.ConvertToFreehold = {
    Id: entity_1.ProcedureIDs.CONVERT_TO_FREEHOLD,
    Name: {
        ar: "تحويل من غير التملك الحر إلى التملك الحر",
        en: "Non Freehold to Freehold",
    },
    Description: {
        ar: "تتيح هذه الخدمة للملاك تحويل العقارات من التملك غير الحر إلى التملك الحر",
        en: "A service that allow owners of property to convert from Non Freehold to Freehold"
    },
    RequireProperty: true,
    IsActive: true,
};
exports.AllTabuProcedures = [exports.TWICService, exports.PropertyDetailCertService, exports.SitePlan, exports.LC, exports.BCSReClassification, exports.PV,
    exports.IPV, exports.ET, exports.OwnershipChange, exports.PropertyCutOff, exports.DelayedPropertyCutOff, exports.PropertyAnnex, exports.DelayedPropertyAnnex, exports.ConvertToFreehold];
